import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const paychecksJourneyRoutes = [
  {
    id: 'paychecks-distribution-summary',
    trackingName: 'View Paychecks Distribution Summary',
    path: 'paychecks/distribution-summary',
    lazy: async () => ({
      Component: (await import('../components/JourneyEditDistributions')).JourneyEditDistributions,
    }),
  },
  {
    id: 'paychecks-add-or-edit-allocation',
    trackingName: 'Add or Edit Paychecks Allocation',
    path: 'paychecks/edit-allocation/:paychecksAllocationId',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddOrEditAllocation')).JourneyAddOrEditAllocation,
    }),
  },
] as const satisfies JourneyRoute[]
